"use strict";

exports.__esModule = true;
exports.mangleOrStripUrls = mangleOrStripUrls;
exports.unmangleUrls = unmangleUrls;

function unmangleUrls(str) {
  if (!str) return str;
  if (typeof str !== "string") return str;
  var urlRegex = /%%TG%%_(.*?)_%%TG%%/g;
  return str.replace(urlRegex, function (outer, innerUrl) {
    if (innerUrl) {
      return "" + decodeURIComponent(innerUrl);
    }

    return outer;
  });
}

function mangleOrStripUrls(str, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      mangleUrls = _ref.mangleUrls,
      doNotMangleOrStripUrls = _ref.doNotMangleOrStripUrls;

  if (!str) return str;
  var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;

  if (mangleUrls || doNotMangleOrStripUrls) {
    if (doNotMangleOrStripUrls) {
      //if doNotMangleOrStripUrls=true, just return the original string
      return str;
    } //if mangleUrls=true, return a URL mangled and encoded string


    return str.replace(urlRegex, function (url) {
      return "%%TG%%_" + encodeURIComponent(url) + "_%%TG%%";
    });
  } //if no options passed, strip all URLs from the string


  return str.replace(urlRegex, function (url) {
    return "";
  });
}